define(function (require) {
    "use strict";

    var LE = require("app");
    var Page = require("ui.components/page/Page");
    var ManageDomainsView = require("manager-views/ManageDomainsView");
    var ManageDomainsModel = require("manager-models/ManageDomainsModel");

    var ManageDomainsController = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        ManageDomainsController = Marionette.Controller.extend({
            pageView: null,
            insideView: null,
            manageDomainsModel: null,

            //<editor-fold desc="Marionette-Functions">
            /*-----------------------------------------------------------------------------------------------*/
            initialize: function(options) {
                this._initialize(options);
            },
            //</editor-fold>

            //<editor-fold desc="publicFunctions">
            /*-----------------------------------------------------------------------------------------------*/
            getView: function() {
                this._initPageView();
                return this.pageView;
            },

            showManageDomainsPage: function() {
                this._showManageDomainsPage();
            },
            //</editor-fold>

            //<editor-fold desc="privateFunctions">
            /*-----------------------------------------------------------------------------------------------*/

            _initialize: function(options) {
                LEManager.logger.info("initializing", "ManageDomainsController:initialize. options = " + options);
                this.channel = LEManager.media.channel("manageDomains");
                this._initPageView();
                this._bindEvents();
            },

            _initPageView: function(){
                LEManager.logger.debug("init page view and listen to its close", "ManageDomainsController:_initPageView");
                this.pageView = new Page({
                    moduleName: LEManager.moduleName,
                    context: LE.context,
                    permutation: Page.PERMUTATION.Dialog,
                    contentWidth: Page.CONTENT_WIDTH.Large,
                    header:{
                        title: LE.translator.translate("LEManager.manage.domains.monitored"),
                        description: LE.translator.translate("LEManager.manage.domains.description"),
                        knowledgePack: {text: LE.translator.translate("LEFramework.global.captions.learnMore"), eventId: "manage-domains"}
                    }
                });
                this.listenTo(this.pageView, "close", this._onPageClose);
            },

            _bindEvents: function() {
                LEManager.logger.debug("init events of the page", "ManageDomainsController:_bindEvents");
                this.listenTo(this.channel, "manageDomains:save", this._onSave);
                this.listenTo(this.channel, "manageDomains:page:close", this._navigateOut);
            },

            _showManageDomainsPage: function() {
                this._showView();
            },

            _showView: function() {
                LEManager.logger.debug("show the manage domains view in the page", "ManageDomainsController:_showView");
                this._showLoader();
                this.manageDomainsModel = new ManageDomainsModel();
                this.manageDomainsModel.fetch({
                    success: _.bind(function () {
                        this.insideView = new ManageDomainsView({model: this.manageDomainsModel});
                        this.pageView.setInsideView(this.insideView);
                        this._closeLoader();
                    }, this),
                    error: _.bind(function() {
                        this._closeLoader();
                        LEManager.notifier.showError(LE.translator.translate("LEFramework.something.went.wrong"));
                        this._navigateOut();
                    }, this)
                });
            },

            _beforeSave: function() {
                this._showLoader();
                this.manageDomainsModel.setManageDomainsData();
                this.listenTo(this.manageDomainsModel, "validated:invalid", this._onSaveInvalid);
            },

            _afterSave: function() {
                this.stopListening(this.manageDomainsModel, "validated:invalid");
                this._closeLoader();
            },

            _onSaveInvalid: function(model, errorObject) {
                LEManager.logger.info("domains could not be saved", "ManageDomainsController:_onSaveInvalid", model);
                this._afterSave();
                LEManager.notifier.showError(LE.translator.translate("LEFramework.errors.generalError.on.page"));
            },

            _onSave: function() {
                LEManager.logger.debug("save the manage domains", "ManageDomainsController:_onSave", this.manageDomainsModel);

                this._beforeSave();

                var options = {
                    ignoreError: true,
                    success: _.bind(this._onSaveSuccess, this),
                    error: _.bind(this._onSaveError, this)
                };
                if(_.isEmpty(this.manageDomainsModel.getWhiteList()) && _.isEmpty(this.manageDomainsModel.getBlackList())) {
                    this.manageDomainsModel.destroy(options);
                } else {
                    this.manageDomainsModel.save(null, options);
                }
            },

            _onSaveSuccess: function(model, resp, options) {
                LEManager.logger.info("domains saved successfully", "ManageDomainsController:_onSaveSuccess", model);
                this._closeLoader();
                this._navigateOut();
            },

            _onSaveError: function(model, resp, options) {
                LEManager.logger.info("domains could not be saved", "ManageDomainsController:_onSaveError", model);
                this._closeLoader();
                LEManager.notifier.showError(LE.translator.translate("LEManager.manage.domains.try.again"));
            },

            _showLoader: function() {
                this.pageView.showLoader();
            },

            _closeLoader: function() {
                this.pageView.closeLoader();
            },

            _onPageClose: function() {
                LEManager.logger.debug("Page component in manage domains is closed. re-init it.", "ManageDomainsController:onPageClose");
                if (this.pageView) {
                    this.stopListening(this.pageView);
                }
                this.pageView = null;
                this.insideView = null;

            },
            _navigateOut: function(){
                LEManager.router.navigateBack();
            }
            //</editor-fold>
        });
    }

    LE.module("LEManager", moduleDefinition);

    return  ManageDomainsController;
});
